import { defineStore } from 'pinia';
import { authService } from '@/services/auth';
import axios from '@/axios';
import { $settings } from '@/provider/settings';

const url = $settings.middlewareURI;

export const useCalendarStore = defineStore('calendar', {
  state: () => ({
    calendarData: {
      resources: {
        rows: [],
      },
      events: {
        rows: [],
      },
    },
    onDropConfig: {},
    proximitySearchParams: {},
  }),

  getters: {
    getEventsData: (state) => state.calendarData.events.rows || [],
    getResourcesData: (state) => state.calendarData.resources.rows || [],
    getOnDropConfig: (state) => state.onDropConfig || {},
    getProximitySearchParams: (state) => state.proximitySearchParams || {},
  },

  actions: {
    async fetchCalendarData(resourceLabels) {
      try {
        const token = await authService.getGraphToken();
        const response = await axios({
          method: 'POST',
          url: `${url}/exp/calendar/search`,
          data: {
            TYPE: { ACT: true, APPOINTMENT: true },
            ACT: { BEARER_TOKEN: token.accessToken },
          },
        });

        const resources = [
          {
            id: 'ACTIVITY',
            name: resourceLabels.activity,
            eventColor: '#EE7816',
          },
          {
            id: 'APPOINTMENT',
            name: resourceLabels.appointment,
            eventColor: '#52AE32',
          },
        ];

        const events = response.data.DATA.SEARCHRESULT.map((event, index) => {
          const resourceId = event.VBELN === '' ? 'APPOINTMENT' : 'ACTIVITY';
          const eventColor =
            resourceId === 'APPOINTMENT' && event.COLOUR
              ? event.COLOUR
              : resources.find(({ id }) => id === resourceId).eventColor;

          return {
            id: index + 1,
            resourceId,
            boId: event.VBELN,
            name: event.SUBJECT,
            createActivity: false,
            key: event.OBJKEY,
            company: event.FIRMA_DESCR,
            person: event.PERSON_DESCR,
            type: event.AKTTYP,
            allDay: !!event.__ITML__IS_ALLDAY,
            startDate: `${event.START} ${event.STARTTIME}`,
            endDate: `${event.END} ${event.ENDTIME}`,
            eventType: event.VBELN === '' ? 'Appointment' : 'Activity',
            draggable: false,
            resizable: false,
            eventColor,
            exchangeId: event.EXCHANGEID,
            lat: (Math.round(event.LATITUDE * 100) / 100).toFixed(6),
            long: (Math.round(event.LONGITUDE * 100) / 100).toFixed(6),
          };
        });

        this.calendarData.resources.rows = resources;
        this.calendarData.events.rows = events;
      } catch (error) {
        console.error(error);
      }
    },

    initCalendar({ onDrop }) {
      this.onDropConfig = onDrop;
    },

    createCalendarEvent(event) {
      this.calendarData.events.rows = [...this.calendarData.events.rows, event];
    },

    resetProximitySearchParams() {
      this.proximitySearchParams = {};
    },

    setProximitySearchParams(parameters) {
      this.proximitySearchParams = parameters;
    },
  },
});
